<p-toast></p-toast>
<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>

<!--********************************************Cadastro Fabrica *********************************************-->

<div class="container-fluid mt-3">
  <p-panel header="Cadastrar Fábrica" styleClass="p-shadow-3">
    <p-toolbar styleClass="mb-4 p-shadow-3">
      <div class="row">
        <div class="col-md col-sm pl-1 pr-1 filter-margin">
          <button pButton label="Novo" pTooltip="Cadastrar uma nova fabrica" icon="pi pi-plus" (click)="inserirDados()"
            class="p-button-sm p-button-mobile-label-empty p-button-success">
          </button>
        </div>
        <div class="col-md col-sm pl-1 pr-1 filter-margin">
          <button pButton label="" pTooltip="Atualizar Tabela" icon="pi pi-refresh" (click)="retornaDados()"
            class="p-button-sm p-button-mobile-label-empty">
          </button>
        </div>
      </div>
    </p-toolbar>
    <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="dados" [rowHover]="true"
      [paginator]="dados?.length > 10" [rows]="10" [showCurrentPageReport]="true" [loading]="loading"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)"
      [rowsPerPageOptions]="[10,20,30,50,100]" [autoLayout]="true" sortMode="multiple" [globalFilterFields]="['nome']"
      paginatorDropdownAppendTo="body">
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 20px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
            [ngStyle]="{'width': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field" class="p-sortable-colum"
              *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
            </p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div *ngIf="col.field != 'status'">
              {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
            </div>
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
              (click)="editDados(dados)" pTooltip="Editar" *ngIf="col.field === 'edit'">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-toast position="top-right"></p-toast>
    <div class="card" *ngIf="dados?.length === 0">
      <div class="card-body bg-no-records p-shadow-3">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </div>
    </div>
  </p-panel>
</div>
<p-dialog [(visible)]="dadosDialog" [style]="{width: '480px'}" [header]="descricaoDialog" [modal]="true"
  styleClass="p-fluid">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="nome">Nome</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.nome" inputId="nome" placeholder="Nome fabrica"
          appendTo="body">
      </div>
      <div class="p-field p-col-12">
        <label for="link">URL</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.link" inputId="link"
          placeholder="Exemplo: https://portalmarca.nbs.app.br" appendTo="body">
      </div>
      <div class="p-field p-col-12">
        <label for="portaBack">Porta Back-End</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.portaBackEnd" inputId="portaBack"
          placeholder="Exemplo: 9999" appendTo="body">
      </div>
      <div class="p-field p-col-12">
        <label for="portaFront">Porta Front-End</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.portaFrontEnd" inputId="portaFront"
          placeholder="Exemplo: 9999" appendTo="body">
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text" (click)="saveDados()"></button>
  </ng-template>
</p-dialog>

<!--********************************************Cadastro Marca ***********************************************-->

<div class="container-fluid mt-3">
  <p-panel header="Cadastrar Marca" styleClass="p-shadow-3">
    <p-toolbar styleClass="mb-4 p-shadow-3">
      <div class="row">
        <div class="col-md col-sm pl-1 pr-1 filter-margin">
          <button pButton label="Novo" pTooltip="Cadastrar uma nova marca" icon="pi pi-plus" (click)="inserirMarca()"
            class="p-button-sm p-button-mobile-label-empty p-button-success">
          </button>
        </div>
        <div class="col-md col-sm pl-1 pr-1 filter-margin">
          <button pButton label="" pTooltip="Atualizar Tabela" icon="pi pi-refresh"
            class="p-button-sm p-button-mobile-label-empty" (click)="pesquisar()">
          </button>
        </div>
      </div>
    </p-toolbar>
    <p-table #dtMarca [value]="dadosMarca" selectionMode="multiple" [loading]="loading" [globalFilterFields]="['idMarca',
    'descricao', 'usuarioCriacao']"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
      [columns]="colsMarca" [autoLayout]="true" [rows]="50">
      <ng-template pTemplate="caption">
        <div>
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dtMarca.filterGlobal($event.target.value, 'contains')"
              placeholder="Filtro Geral" />
          </span>
        </div>
      </ng-template>
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dadosMarca?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 10px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of colsMarca" [ngStyle]="{'width': col.width}"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dadosMarca let-columns="columns">
        <tr>
          <td *ngFor="let col of colsMarca">
            {{dadosMarca[col.field]}}
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
              (click)="editMarca(dadosMarca)" pTooltip="Editar" *ngIf="col.field === 'edit'">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator *ngIf="totalRegistros > 5" [rows]="tamanhoPagina" [(first)]="first" [totalRecords]="totalRegistros"
      [rowsPerPageOptions]="[10,20,30,50,100]" (onPageChange)="eventoPaginacao($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Total de Registros: {totalRecords}">
    </p-paginator>
    <p-dialog [(visible)]="editDialogMarca" [style]="{width: '480px'}" [header]="descricaoDialog" [modal]="true"
      styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12">
            <label for="codigo">Código Marca</label>
            <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dadoMarca.idMarca" inputId="codigo"
              placeholder="Código Marca" appendTo="body" [disabled]="habilitar">
          </div>
          <div class="p-field p-col-12">
            <label for="nomeMarca">Marca</label>
            <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dadoMarca.descricao" inputId="nomeMarca"
              placeholder="Exemplo: Marca Exemplo" appendTo="body">
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="hideDialog()"></button>
        <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text"
          (click)="salvarMarca()"></button>
      </ng-template>
    </p-dialog>
    <p-toast position="top-right"></p-toast>
  </p-panel>
</div>

<!--******************************************** Cruzamento Fabrica X Marca **********************************-->

<div class="container-fluid mt-3">
  <p-panel header="Cruzamento Fabrica x Marca" styleClass="p-shadow-3">
    <p-toolbar styleClass="mb-4 p-shadow-3">
      <div class="row">
        <div class="col-10 pl-1 pr-1 filter-margin">
          <button pButton label="Novo Cruzamento" icon="pi pi-plus" (click)="adicionarCruzamento()"
            class="p-button-sm p-button-mobile-label-empty p-button-success">
          </button>
        </div>
        <div class="col-2 pl-0 pr-1 filter-margin">
          <button pButton icon="pi pi-refresh" class="p-button-sm p-button-mobile-label-empty"
          (click)="pesquisarCruzamento()">
          </button>
        </div>
      </div>
      <div>
        <div class="col-10 pl-1 pr-1 filter-margin">
          <button pButton label="Restart" icon="pi pi-refresh" (click)="displayBasic2=true"
            class="p-button-sm p-button-mobile-label-empty">
          </button>
        </div>
      </div>
    </p-toolbar>
    <p-table #dt [value]="dadosCruzamento" selectionMode="multiple" [loading]="loading"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
      [columns]="colsCruzamento" [autoLayout]="true" [rows]="50">
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dadosCruzamento?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3" style="padding: 10px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dadosCruzamento let-columns="columns">
        <tr>
          <td *ngFor="let col of colsCruzamento">
            {{dadosCruzamento[col.field]}}
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1 mb-1"
              (click)="editarCruzamento(dadosCruzamento)" pTooltip="Editar" *ngIf="col.field === 'edit'">
            </button>
            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-btn-sm p-mr-1"
              (click)="excluirCruzamento(dadosCruzamento)" pTooltip="Excluir" *ngIf="col.field === 'edit'">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-dialog [(visible)]="editCruzamento" [style]="{width: '521px'}" [header]="descricaoDialog" [modal]="true"
      styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-5">
            <label for="codigo">Fabrica</label>
            <select class="form-control form-control-sm" type="number" [disabled]="true" [(ngModel)]="Fabrica">
              <option *ngFor="let item of dados" [value]="item.id">{{item.id + ' - ' + item.nome}}</option>
            </select>
          </div>
          <div class="p-field p-col-1" style="margin-top: 31px;">
            <h5> X </h5>
          </div>
          <div class="p-field p-col-6">
            <label for="nomeMarca">Marca</label>
            <select class="form-control form-control-sm" type="number" [(ngModel)]="Marca">
              <option translate value="">Selecione uma Marca</option>
              <option *ngFor="let item of dadosDropdown" [value]="item.idMarca">{{item.idMarca + ' - ' +item.nomeMarca}}
              </option>
            </select>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="hideDialog()"></button>
        <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text"
          (click)="saveCruzamento()"></button>
      </ng-template>
    </p-dialog>
    <p-toast position="top-right"></p-toast>
  </p-panel>
  <p-dialog [(visible)]="displayBasic2" header="Atenção" [style]="{width: '26vw'}" [modal]="true"> 
      <p>Este processo irá parar o funcionamento da aplicação por cerca de 40 segundos. Deseja continuar?</p>
    <ng-template pTemplate="footer">
      <button pButton icon="pi pi-times" (click)="displayBasic2=false" label="No"></button>
      <button pButton icon="pi pi-check" (click)="restart()" label="Yes"></button>
    </ng-template>
  </p-dialog>
</div>

<!--******************************************** Parâmetros Fábrica **********************************-->

<div class="container-fluid mt-3">
  <p-panel header="Parâmetros Fábrica" styleClass="p-shadow-3">
    <p-toolbar styleClass="mb-4 p-shadow-3">
      <div class="row">
        <div class="col-10 pl-1 pr-1 filter-margin">
          <button pButton label="Salvar Parâmetros" icon="pi pi-save" (click)="salvarParametros()"
            class="p-button-sm p-button-mobile-label-empty p-button-success">
          </button>
        </div>
        <div class="col-2 pl-0 pr-1 filter-margin">
          <button pButton icon="pi pi-refresh" class="p-button-sm p-button-mobile-label-empty"
          (click)="carregarParametros()">
          </button>
        </div>
      </div>
      
        <!-- Aviso de alterações não salvas -->
        <div class="row mt-2" *ngIf="mostrarAvisoAlteracoesNaoSalvas">
          <div class="col-10 pl-1 pr-1">
            <div class="alert alert-info d-flex align-items-center" role="alert">
              <i class="pi pi-info-circle"></i>
              <span>Você tem alterações não salvas nos parâmetros. Clique em "Salvar Parâmetros" para confirmar as mudanças.</span>
            </div>
          </div>
          <div class="col-2 pl-0 pr-1">
            <!-- Espaço vazio para alinhar com o botão de refresh -->
          </div>
        </div>
        
        <!-- Aviso de reinicialização necessária -->
        <div class="row mt-2" *ngIf="mostrarAvisoReinicializacao">
          <div class="col-10 pl-1 pr-1">
            <div class="alert alert-warning d-flex align-items-center" role="alert">
              <i class="pi pi-exclamation-triangle"></i>
              <span>Alteração no parâmetro "Processar Arquivos" detectada. Esta alteração irá reiniciar a aplicação para aplicar as mudanças.</span>
              <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-sm p-button-danger"
                      (click)="cancelarAlteracaoProcessarArquivos()">
              </button>
            </div>
          </div>
          <div class="col-2 pl-0 pr-1">
            <!-- Espaço vazio para alinhar com o botão de refresh -->
          </div>
        </div>
    </p-toolbar>
    
     <div class="p-fluid p-formgrid p-grid">
       <div class="p-field p-col-6">
         <div class="parametros-inputswitch d-flex align-items-center">
           <p-inputSwitch [(ngModel)]="parametrosFabrica.processarArquivos" (onChange)="onProcessarArquivosChange()"></p-inputSwitch>
           <label class="parametros-label" for="processarArquivos">Processar Arquivos</label>
         </div>
       </div>
       <div class="p-field p-col-6">
         <div class="parametros-inputswitch d-flex align-items-center">
           <p-inputSwitch [(ngModel)]="parametrosFabrica.envioAgregado" (onChange)="onEnvioAgregadoChange()"></p-inputSwitch>
           <label class="parametros-label" for="envioAgregado">Envio Agregado</label>
         </div>
       </div>
       <div class="p-field p-col-6">
        <div class="parametros-inputswitch d-flex align-items-center">
          <p-inputSwitch [(ngModel)]="parametrosFabrica.necessitaModelo" (onChange)="onNecessitaModeloChange()"></p-inputSwitch>
          <label class="parametros-label" for="necessitaModelo">Necessita Modelo</label>
        </div>
      </div>
      <div class="p-field p-col-6">
        <div class="parametros-inputswitch d-flex align-items-center">
          <p-inputSwitch [(ngModel)]="parametrosFabrica.obrigatoriedadeTipoItem" (onChange)="onNecessitaModeloChange()"></p-inputSwitch>
          <label class="parametros-label" for="necessitaModelo">Preço de Peças utiliza cadastro de Tipo de Itens</label>
        </div>
      </div>
     </div>

            

  
    <p-toast position="top-right"></p-toast>
  </p-panel>
</div>